import { environment } from 'environments/environment';

export const TURBINE_COMPETENCY_CATEGORY = 'TURBINE';

export function isSseSiteOwnerId(siteOwnerId: number | string | null | undefined): boolean {
  return Number(siteOwnerId) === environment.SSE_OWNER_SKYLARK_ID;
}

export function hasSseCompetencyRestrictions(user: any, siteOwnerId: number | string | null | undefined): boolean {
  return !!(user && user.isSseContext) && isSseSiteOwnerId(siteOwnerId);
}

export function canManageCompetencyForSseRoute(
  competency: any,
  canEditTurbineCompetencies: boolean,
  canEditNonTurbineCompetencies: boolean,
): boolean {
  return isTurbineCompetencyCategory(competency)
    ? !!canEditTurbineCompetencies
    : !!canEditNonTurbineCompetencies;
}

export function isTurbineCompetencyCategory(competency: any): boolean {
  return competency && competency.competencyCategory === TURBINE_COMPETENCY_CATEGORY;
}

export function isSelfWorker(user: any, workerSkylarkUserId: number | string | null | undefined): boolean {
  return !!user && workerSkylarkUserId != null && Number(user.id) === Number(workerSkylarkUserId);
}

// Site delegates cannot add, approve or reject their own competencies - the competency API rejects
// those calls, so the admin competency screens must not offer them for the delegate's own record.
// They manage their own competencies from 'My Competencies' like any other worker.
export function isDelegateManagingSelf(user: any, workerSkylarkUserId: number | string | null | undefined): boolean {
  return !!user && user.routeRole === 'site-delegate' && isSelfWorker(user, workerSkylarkUserId);
}
